import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class JoinRequestService {
  public Data = new BehaviorSubject(null)
  
  constructor(private _HttpClient:HttpClient) { }
  GetJoinRequest():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/JoinRequest/Get`);
  }
  GetEmploymentRequest(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/JoinRequest/GetEmploymentRequest`,data);
  }
  GetVolunteeringRequest(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/JoinRequest/GetVolunteeringRequest`,data);
  }
  GetCoursesRequest(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/JoinRequest/GetCoursesRequest`,data);
  }
  DeleteJoinRequest(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/JoinRequest/Delete?id=${id}`);
  }

  CreateJoinRequest(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/JoinRequest/Create`,data);
  }
  UpdateJoinRequest(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/JoinRequest/Update`,data)
  }
}
